export class BaseService {
  constructor({ blocker, blockerKey, apiProvider }) {
    this.blocker = blocker
    this.blockerKey = blockerKey
    this.apiProvider = apiProvider
  }

  /**
   * @param {string} method
   * @param {(error: Error) => any} errorHandler

   * @returns
   */
  async _makeCall(method, errorHandler, config, raw = false) {
    this._block()
    return this.apiProvider({ method, ...config })
      .then(res => {
        return raw ? res : res.data
      })
      .catch(error => {
        if (errorHandler) {
          errorHandler(error)
        }
        throw error
      })
      .finally(() => this._unblock())
  }

  /** @protected */
  _block() {
    if (this.blocker) this.blocker[this.blockerKey] = true
  }

  /** @protected */
  _unblock() {
    if (this.blocker) delete this.blocker[this.blockerKey]
  }
}
